import { Pipe, PipeTransform } from '@angular/core';

import { EmptyValues } from '@shared/enums/common.enum';

const CUSTOM_CURRENCY_DOTS_COMMAS_PATTERN = /\B(?=(\d{3})+(?!\d))/g;

@Pipe({
  name: 'customCurrencyDotsCommas',
})
export class CustomCurrencyDotsCommasPipe implements PipeTransform {
  transform(value: string | number | null, showDecimals = true, shorten = false): string {
    if (!value || value === EmptyValues.DASH) {
      return String(value);
    }

    const num = Number(value);
    if (isNaN(num)) {
      return String(value);
    }

    let displayValue = num;
    let suffix = '';

    if (shorten) {
      if (Math.abs(num) >= 1_000_000_000) {
        displayValue = num / 1_000_000_000;
        suffix = 'B';
      } else if (Math.abs(num) >= 1_000_000) {
        displayValue = num / 1_000_000;
        suffix = 'M';
      } else if (Math.abs(num) >= 1_000) {
        displayValue = num / 1_000;
        suffix = 'K';
      }
    }

    const formattedValue = showDecimals ? displayValue.toFixed(2) : Math.round(displayValue).toString();

    if (!shorten) {
      const parts = formattedValue.split('.');
      const wholePart = parts[0];
      const fractionalPart = showDecimals && parts.length > 1 ? '.' + parts[1] : '';
      const withCommas = wholePart.replace(CUSTOM_CURRENCY_DOTS_COMMAS_PATTERN, ',');
      return '$' + withCommas + fractionalPart;
    }

    return '$' + formattedValue + suffix;
  }
}
